import { createClient } from '@supabase/supabase-js';

const supabase = createClient(
  'https://ngiirsvdmqzqxnxyjacv.supabase.co',
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im5naWlyc3ZkbXF6cXhueHlqYWN2Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzA2NTI3MjQsImV4cCI6MjA4NjIyODcyNH0.vmLbk5AnVtwwPlnpH-o7w-o4MVaqZ8puwU4slvM-dp4'
);

export default supabase;
